import axios from 'axios'

const URL = process.env.VUE_APP_RAILS_URL

const listOrganization = async (body) => {
  try {
    const endpoint = `${URL}/shopkeeper/v2/organizations`

    const params = {
      page: body.page,
      active: body.active,
      name: body.name,
      category_id: body.category_id,
    }

    const response = await axios.get(endpoint, { params })
    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

const organizationById = async (id) => {
  try {
    let endpoint = `${URL}/shopkeeper/v2/organizations/${id}`
    const response = await axios.get(endpoint)

    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

const editOrganization = async (id, body) => {
  try {
    const endpoint = `${URL}/shopkeeper/v2/organizations/${id}`
    const response = await axios.patch(endpoint, body)

    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

const createOrganization = async (body) => {
  try {
    const endpoint = `${URL}/shopkeeper/v2/organizations`
    const formData = new FormData()

    if (body.description) formData.append('description', body.description)
    if (body.short_description)
      formData.append('short_description', body.short_description)
    if (body.cashback_value && body.cashback_type) {
      formData.append('cashback_value', body.cashback_value)
      formData.append('cashback_type', body.cashback_type)
    }
    if (body.facebook) formData.append('facebook', body.facebook)
    if (body.instagram) formData.append('instagram', body.instagram)

    // Uploads de arquivo (CarrierWave). logo_image e ao menos um top_background
    // são obrigatórios no backend (Organization.create!).
    if (body.logo_image) formData.append('logo_image', body.logo_image)
    if (body.top_background_image)
      formData.append('top_background_image', body.top_background_image)
    if (body.top_background_image_v1)
      formData.append('top_background_image_v1', body.top_background_image_v1)
    if (body.banner_image_v1)
      formData.append('banner_image_v1', body.banner_image_v1)
    if (body.banner_image) formData.append('banner_image', body.banner_image)
    if (body.banner_without_cashback_image)
      formData.append(
        'banner_without_cashback_image',
        body.banner_without_cashback_image
      )
    if (body.banner_without_cashback_image_v1)
      formData.append(
        'banner_without_cashback_image_v1',
        body.banner_without_cashback_image_v1
      )
    if (body.photo) formData.append('photo', body.photo)

    if (body.tags) formData.append('tags', body.tags)
    if (body.category_ids && body.category_ids.length > 0)
      body.category_ids.forEach((id) => formData.append('category_ids[]', id))
    if (typeof body.active === 'boolean')
      formData.append('active', body.active)
    if (typeof body.pined === 'boolean') formData.append('pined', body.pined)

    body.promotion_providers.forEach((p) =>
      formData.append('promotion_providers[]', p)
    )
    formData.append('name', body.name)
    if (body.category_id) formData.append('category_id', body.category_id)
    formData.append('contact_telephone', body.contact_telephone)
    formData.append('cnpj', body.cnpj)
    formData.append('navigation_option', body.navigation_option)

    const response = await axios.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

const promotionsRedeemed = async (body) => {
  try {
    let endpoint = `${URL}/shopkeeper/v2/organizations/${
      body.branchId
    }/orders?page=${body.page}`
    const response = await axios.get(endpoint)
    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

const editMultiCashback = async (body) => {
  try {
    const endpoint = `${URL}/shopkeeper/v2/organizations/multi_edit`
    const response = await axios.patch(endpoint, body)

    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

const toogleOrganizationForAllCostumers = async (organizationId, toogleEnable) => {
  try {
    const endpoint = `${URL}/shopkeeper/v2/organizations/${organizationId}`
    const params = {
      all_projects: toogleEnable,
    }
    const response = await axios.patch(endpoint, params)

    return {
      status: response.status,
      data: response.data,
    }
  } catch (err) {
    return {
      status: err.response.status,
      message: err.response.data.error,
    }
  }
}

export {
  createOrganization, editMultiCashback, editOrganization, listOrganization,
  organizationById, promotionsRedeemed, toogleOrganizationForAllCostumers
}

